<template>
    <div id="app">

    <vs-row vs-type="flex" vs-justify="space-between" >
        <vs-col  vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="3">
            <vs-button @click="newEvent" color="primary" type="filled">+ Sala</vs-button>
        </vs-col>
    </vs-row>

    <br/>
    <vs-popup  :active.sync="showModal" :title="title" @close="closepop" fullscreen>
        <vs-row vs-justify="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">

                <br/>
                <div class="vx-row mb-2">                    
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>SPA</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="7">
                        <v-select
                            class="selectWidth360"
                            label-placeholder=""
                            v-model="rowSelected.spa"        
                            v-validate="'required'"  
                            name="spa"  
                            label="label"
                            :clearable="false" 
                            :options="spasvg"                    
                        >
                    
                        </v-select>
                    </vs-col>
                    <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                        <span class="text-danger text-sm" v-show="errors.has('spa')">{{ errors.first('spa') }}</span>
                    </vs-col>                    
                </div>  
                
                <br/>
                <div class="vx-row mb-2">                    
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Nome</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="7">
                       <vs-input class="w-full" v-model="rowSelected.name" v-validate="'required'"  name="nome" autocomplete="off" />
                    </vs-col>
                    <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                        <span class="text-danger text-sm" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>
                    </vs-col>                    
                </div>

                <br/>
                <div class="vx-row mb-2">                    
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Descrição</h5>
                    </vs-col>
                     <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="7">
                        <vs-textarea v-model="rowSelected.description" name="descricao" height="75" />
                    </vs-col>
                    <vs-col vs-offset="1" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                        <span class="text-danger text-sm" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</span>
                    </vs-col>                    
                </div>      

                <br/>
                <div class="vx-row mb-2">                    
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Cor</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="7">
                        <v-select
                            autocomplete
                            class="selectWidth200"
                            placeholder=""
                            v-model="rowSelected.color"
                            v-validate="'required'"  
                            name="cor"
                            id="rowSelected-room_color"
                            label="color_description"
                            :clearable="false" 
                            :options="colors"                 
                        >            
                        
                        </v-select>
                    </vs-col>
                    <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                        <span class="text-danger text-sm" v-show="errors.has('cor')">{{ errors.first('cor') }}</span>
                    </vs-col>                
                </div>

                <br/>
                <div class="vx-row">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="7">
                            <feather-icon class="mr-1" icon="FilterIcon"></feather-icon>
                            <v-select
                                class="selectWidth360"
                                v-model="filter"
                                name="filter"
                                label="name"
                                :clearable="false"
                                :options="filterCategories"
                                placeholder="Categoria"
                            >
                            </v-select>
                        </vs-col>
                </div>
                <div class="vx-row">                
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12" >
                        <h5>Eventos</h5>
                    </vs-col>
                    <vs-col vs-type="inline" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                        <vs-list>
                            <div class="list-header-with-btn">
                                <vs-list-header title="Disponíveis" color="primary"></vs-list-header>
                                
                                <vs-button 
                                    class="mb-2" 
                                    title="Mover tudo"
                                    @click="transferAllEvents"
                                    icon-pack="feather" 
                                    icon="icon-chevrons-right"
                                    type="flat">
                                </vs-button> 
                            </div>
                            
                            <draggable :list="eventosSpa" group="people" class="p-2 cursor-move firstDraggable" animation="300" @add="changingList" @start="onDragStart" @end="onDragEnd">
                                <vs-list-item :class="{ drag_selected: selectedEvents.includes(listItem.event_id) }" v-for="(listItem, index) in eventosSpa" :key="listItem.event_id" :title="listItem.name" :data_category="listItem.event_category_id" :data_event="listItem.event_id" @mouseup.native="selectItem($event,listItem.event_id)">
                                </vs-list-item>
                            </draggable>
                        </vs-list> 
                    </vs-col>
                    <vs-col vs-type="inline" vs-justify="center" vs-align="center" vs-lg="5" vs-sm="4" vs-xs="12">
                        <vs-list>
                            <div class="list-header-with-btn">
                                <vs-list-header title="Selecionados" color="primary"></vs-list-header>
                                
                                <vs-button 
                                    class="mb-2" 
                                    title="Mover tudo"
                                    @click="removeAllEvents"
                                    icon-pack="feather" 
                                    icon="icon-chevrons-left"
                                    type="flat">
                                </vs-button> 
                            </div>

                            <draggable :list="rowSelected.eventos" group="people" class="p-2 cursor-move" animation="300" @add="changingList" @start="onDragStart" @end="onDragEnd">
                                <vs-list-item :class="{ drag_selected: selectedEvents.includes(listItem.event_id) }" v-for="(listItem, index) in rowSelected.eventos" :key="listItem.event_id" :title="listItem.name" :data_category="listItem.event_category_id" :data_event="listItem.event_id" @mouseup.native="selectItem($event,listItem.event_id)">
                                </vs-list-item>
                            </draggable>
                        </vs-list>
                    </vs-col>                    
                    
                </div>              
                <div class="vx-row mb-2">   
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                        <span class="text-danger text-sm" v-show="errors.has('eventos')">{{ errors.first('eventos') }}</span>
                    </vs-col>  
                </div>                                                    

                <br/>
                <div class="vx-row mb-6">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="3">
                        <h5>Estado</h5>
                    </vs-col>
                    <vs-col vs-offset="-1" vs-type="flex" vs-justify="left" vs-align="center" vs-w="7">
                        <vs-radio v-model="rowSelected.status" vs-value="1" color="primary"
                            v-validate="'required'"
                            name="estado" 
                        >
                            Activo
                        </vs-radio>
                        &nbsp;&nbsp;&nbsp;
                        <vs-radio v-model="rowSelected.status" vs-value="0" color="danger"
                                v-validate="'required'"
                            name="estado" 
                        >
                            Inactivo
                        </vs-radio>  
                    </vs-col>   
                </div>

                <div class="vx-row mb-2">   
                    <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                        <span class="text-danger text-sm" v-show="errors.has('estado')">{{ errors.first('estado') }}</span>
                    </vs-col>  
                </div>
        
                <br/>
                <vs-row vs-type="flex" vs-justify="center">
                    <vs-button v-if="displayNew" @click="addSala()" class="mr-3 mb-2" icon-pack="feather" icon="icon-check-circle" >Novo</vs-button>
                    <vs-button v-if="displayEdit" @click="editSala()" class="mr-3 mb-2" icon-pack="feather" icon="icon-check-circle" >Gravar</vs-button>
                    <vs-button color="warning" type="border" class="mb-2" 
                        @click="clearFields"
                        icon-pack="feather" icon="icon-delete"
                    >
                        Limpar
                    </vs-button>               
                </vs-row>

        </vs-col>
    </vs-row>
    </vs-popup>

    <vs-table        
        v-model="selectedSala"
        pagination
        max-items="10"
        search
        noDataText="Não foram encontrados registos"
        @selected="handleSala"
        :data="salasSpa"
        :stripe="true"
        :hoverFlat="true"
    >
    
    <template slot="header">
        <h3>
          Lista de Salas
        </h3>
    </template>
    
    <template slot="thead">
        <vs-th>
        </vs-th>
        <vs-th>
            Sala
        </vs-th>
        <vs-th>
            Spa
        </vs-th>
        <vs-th>
            Hotel
        </vs-th>
        <vs-th>
            Cor
        </vs-th>
        <vs-th>
            Estado
        </vs-th>

    </template>
    
    <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :state="indextr % 2 == 0 ?'primary':indextr == 668?'danger':null">
            <vs-td :data="data[indextr].name">
            </vs-td>

            <vs-td :data="data[indextr].name">
            {{data[indextr].name}} 
            </vs-td>

            <vs-td :data="data[indextr].spa_name">
            {{data[indextr].spa.spa_name}}
            </vs-td>

            <vs-td :data="data[indextr].hotel_name">
            {{data[indextr].hotel_name}}
            </vs-td>

            <vs-td :data="data[indextr].color_description">
            {{data[indextr].color.color_description}}
            </vs-td>

            <vs-td v-if="data[indextr].status == 0" :data="data[indextr].status">
                Inactivo
            </vs-td>
            <vs-td v-if="data[indextr].status == 1" :data="data[indextr].status">
                Activo
            </vs-td>
        </vs-tr>
    </template>

    </vs-table>

    </div>
</template>

<style scoped>
    .list-header-with-btn  { position: relative; }
    .list-header-with-btn button {
        position: absolute;
        top: 0;
        right: 0;
    }

    .drag_selected {
        background-color: rgb(var(--vs-primary));
        color: #FFFFFF;
    }
</style>

<script>
import draggable from 'vuedraggable'

import themeConfig from '@/../themeConfig.js';

import axios from 'axios';   

import { Validator } from 'vee-validate';

const dict = {
  custom: {
    nome: {            
        required: 'Campo Obrigatório ',
    },
    spa: {
        required: 'Campo Obrigatório ',
    },
    estado: {
        required: 'Campo Obrigatório ',
    },
    cor: {
        required: 'Campo Obrigatório ',
    },
    eventos: {
        required: 'Escolha pelo menos 1 Evento',
    },
  }
};
Validator.localize('pt', dict);

export default{
    name: 'sala',
    data: function() {
        return {
            displayNew :false,
            selectedEvents: [],
            displayEdit : false,
            showModal: false,
            title: '',
            spa: '',
            nome: '',
            descricao: '',
            estado: '',
            room: {},
            selectedSala: {},
            rowSelected: {
                eventos: [],
            } ,
            salasSpa: [],
            colors: [],
            eventosSpa: [],
            originalEventosSpa: [],
            spasvg: [],
            filterSearch: '',
            filter: {
                event_category_id: '0',
                name: 'Todas'
            },
            filterCategories: [],
            eventosSpaTemp: [],
        }
    }, 

    components: {
        draggable
    }, 

    methods: {
        getSpaRoomColors(){

            let that = this; 

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/room/colors?token='+window.localStorage.getItem('usertoken'),
            })
            .then(function (res) 
            { 
                if(res.status == 200)
                { 
                    that.colors=res.data;                
                }                                      
            })
            .catch( function (err) {
                console.log(err);
            })
        },
                
        handleSala(tr) {
            this.title ='Editar Sala';          

            this.rowSelected = JSON.parse(JSON.stringify(tr));  
            this.eventosSpaTemp = JSON.parse(JSON.stringify(tr.eventos));

            this.displayEdit = true;
            this.displayNew = false;

            this.getRemainingSpaEventos(this.rowSelected);

            let x = document.getElementById('rowSelected-room_color').getElementsByTagName('input')[0];

            let att =  document.createAttribute("autocomplete");
            att.value = "off";

            x.setAttributeNode(att);

        },

        addSala() {
            this.$validator.validateAll().then(result => {
                if (result){   
                    let that = this;

                    axios({
                        method: 'post',
                        url: themeConfig.apiurl + '/spa/new/room',
                        data: {
                            room: this.rowSelected,
                            token: window.localStorage.getItem('usertoken'),
                        }
                    })
                    .then(function (response) {                          
                        if(response.status == 200){

                            that.notify('Registo inserido com sucesso', 'green');
                            that.showModal = false;
                            that.getSpaSalas();
                        }        
                    })
                    .catch(function (error){
                        console.log(error.response);
                    });

                }
            });
        },

        editSala(){
            let that = this;

            axios({
                method: 'put',
                url: themeConfig.apiurl + '/spa/modify/room/' + this.rowSelected.room_id,
                data: {
                    room: that.rowSelected,
                    token: window.localStorage.getItem('usertoken'),
                }
            }).then(function (response) {                           
                if(response.status == 200){   
                    if(response.data === 'ERROR1'){
                        that.notify('Erro - Falha a encontrar a sala.', 'red');
                    }else{
                        that.notify('Registo modificado com sucesso.', 'green');
                        that.showModal = false;
                        that.getSpaSalas();
                    }
                }        
            }).catch(function (error){
                console.log(error.response);
            });
        },

        getSpaSalas(){
            let that = this;
            this.$vs.loading();

            let spas_ids = [];
            for (let i = 0; i < that.spasvg.length; i++) {
                spas_ids.push(that.spasvg[i].spa_id);
            }

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/rooms?token=' + window.localStorage.getItem('usertoken'),
                params: {
                    spas_ids: spas_ids,
                }
            })
            .then(function (res) { 
                if(res.status == 200){ 
                    that.salasSpa = res.data.map(linha => {
                        return {
                            ...linha,
                            eventos: (linha.eventos || []).filter(el => el.status == 1)
                        };
                    });

                    that.$store.dispatch('storeListSpaRooms',that.salasSpa);
                }                                      
            }).catch( function (err) {
                console.log(err);
            }).then(function (res){
                that.$vs.loading.close(); 
            });
        },

        getSpaEventos(){
            let that = this;

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/events/low/detail?token='+window.localStorage.getItem('usertoken'),
            })
            .then(function (res) { 
                if(res.status == 200)
                { 
                    that.eventosSpa=res.data;                

                    that.originalEventosSpa = res.data; 
                }                                      
            })
            .catch( function (err) {
                console.log(err);
            })    
        }, 

        getRemainingSpaEventos(rowSelected) {
            let that = this; 
            this.$vs.loading();
            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/remaining/events?token='+window.localStorage.getItem('usertoken'),
                params: {
                    room_id: this.rowSelected.room_id,
                }
            }).then(function (res){ 
                if(res.status == 200){   
                    that.eventosSpa = res.data;
                    for (let i = 0; i < that.eventosSpa.length; i++) {
                        that.eventosSpaTemp.push(that.eventosSpa[i])
                    }
                    that.getEventCategories();
                    that.showModal = true; 
                }                                      
            }).catch( function (err) {
                console.log(err);
            }).then(function (response) {
                that.$vs.loading.close();
            });  
        },

        newEvent() {
            this.title ='Adicionar Sala';

            this.displayNew = true;
            this.displayEdit = false;

            this.rowSelected.eventos = [];

            this.eventosSpa = JSON.parse(JSON.stringify(this.originalEventosSpa));
            this.eventosSpaTemp = JSON.parse(JSON.stringify(this.originalEventosSpa));
            this.getEventCategories();

            this.showModal = true;
        },
        getEventCategories(){
            this.$vs.loading();
            let that = this;
            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/category/list?token='+window.localStorage.getItem('usertoken'),
            })
            .then(function (res) {
                if(res.status == 200){
                    let list = res.data;

                    that.filterCategories = [
                        {
                            event_category_id: '0',
                            name: 'Todas'
                        }
                    ];
                    for (let i = 0; i < list.length; i++) {
                        that.filterCategories.push(list[i]);
                    }
                }                                      
            })
            .catch( function (err) {
                console.log(err);
            })
            .then(function (response) {
                that.$vs.loading.close();
            }); 
        },
        closepop(){
            if(this.$validator.errors.items.length > 0)
            {                   
                while(this.$validator.errors.items.length > 0)
                {
                    this.$validator.errors.items.pop();
                }
            }
            this.eventosSpa = [];
            this.rowSelected.eventos = [];
            this.filterSearch = '';
            this.resetFilter();
            this.showModal = false; 
        },

        clearFields(){
            Object.keys(this.rowSelected).forEach(k =>  this.rowSelected[k] = '');
            this.filterSearch = '';
            this.resetFilter();
            this.rowSelected.eventos = [];
        },
        resetFilter(){
            this.filter = [
                {
                    event_category_id: '0',
                    name: 'Todas'
                }
            ];
        },
        getSpas(){
            this.$vs.loading();
            let that = this;
            let session = JSON.parse(window.localStorage.getItem('userSession'));  

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/spas/byTherapist/' + session.id + '?token=' + window.localStorage.getItem('usertoken'),
            }).then(function (res) { 
                if(res.status == 200){   
                    that.spasvg = res.data.map( function(value) {
                        value.label = value.name + ' | ' + value.hvg_nome;
                        return value;
                    });

                    that.getSpaSalas();
                }                                                      
            }).catch( function (err) {
                console.log(err);
            }).then(function (res){
                that.$vs.loading.close(); 
            })
        },
        changingList: function (evt) {
            let str = evt.to.attributes[0].value;
            let firstDraggable = str.includes("firstDraggable");
            if(firstDraggable){
                this.filterDisponiveis(this.filter.event_category_id);
            }

        },
        transferAllEvents(){
            this.rowSelected.eventos = JSON.parse(JSON.stringify(this.eventosSpaTemp));
            this.eventosSpa = [];

            this.selectedEvents = [];
            this.draggedItems = [];
        },
        removeAllEvents(){
            this.eventosSpa = JSON.parse(JSON.stringify(this.eventosSpaTemp));
            this.rowSelected.eventos = [];

            this.selectedEvents = [];
            this.draggedItems = [];
        },
        selectItem(event, id) {
            if (event.button != 0) return;
            
            let index = this.selectedEvents.indexOf(id)

            if (index === -1) {
                this.selectedEvents.push(id)
            } else {
                this.selectedEvents.splice(index, 1)
            }
        },  

        onDragStart(evt) {
            let list = evt.from.__vue__.list
            let draggedItem = list[evt.oldIndex]

            if (this.selectedEvents.includes(draggedItem.event_id)) {
                this.draggedItems = list.filter(item =>
                this.selectedEvents.includes(item.event_id)
            )
            } else {
                this.draggedItems = [draggedItem]
                this.selectedEvents = [draggedItem.event_id]
            }
        },

        onDragEnd(evt) {
            if (!this.draggedItems.length) return;

            let fromList = evt.from.__vue__.list;
            let toList = evt.to.__vue__.list;

            let ids = this.selectedEvents;

            let removedItems = [];
            for (let i = fromList.length - 1; i >= 0; i--) {
                if (ids.includes(fromList[i].event_id)) {
                    removedItems.unshift(fromList[i]);
                    fromList.splice(i, 1);
                }
            }

            toList.splice(evt.newIndex, 0, ...removedItems);

            this.selectedEvents = [];
            this.draggedItems = [];
        },

        filterDisponiveis(new_val){
            // volta a colocar todos os eventos no array dos disponiveis
            this.eventosSpa = JSON.parse(JSON.stringify(this.eventosSpaTemp));

            for (let i = 0, k = 0; k < this.eventosSpaTemp.length; i++, k++) {
                let cut = 0;
                // retira dos disponiveis os eventos que estao nos selecionados
                for (let j = 0; j < this.rowSelected.eventos.length; j++) {
                    if(this.rowSelected.eventos[j].event_id == this.eventosSpa[i].event_id){
                        cut = 1;
                        this.eventosSpa.splice(i, 1);
                        break;
                    }
                }
                if(typeof new_val != 'undefined' && new_val != 0 && cut == 0){
                    // retira dos disponiveis os que nao sao iguais ao filtro
                    if(this.eventosSpa[i].event_category_id != new_val){
                        cut = 1;
                        this.eventosSpa.splice(i, 1);
                    }
                }
                if(cut == 1){
                    i--;
                }
            }

        }

    },
    created() {
        this.getSpas();

        this.getSpaRoomColors();

        this.getSpaEventos();
    },

    watch: {
        showModal(new_val,old_val) {
            if(!new_val){
                this.clearFields();        
            }
        },
        'filter.event_category_id': function (new_val, old_val){
            this.filterDisponiveis(new_val);
            
        }
    },
}

</script>
